<template>
  <div
    class="verifyBox"
    @mousedown="drag"
    @mousemove.prevent="move"
    @mouseleave="leave"
    @mouseup.prevent="end"
  >
    <div class="height m10">
      <span class="height-left">拖动滑块完成拼图,验证通过继续查询</span>
    </div>

    <!-- 图片 -->
    <div class="drag m10">
      <!-- 大图 -->
      <div class="bigimg">
        <img :src="DataBigImg" id="DataBigImg" />
      </div>
      <!-- 小图 -->
      <div class="smallimg" id="bigimg">
        <img :src="Smallimg" />
      </div>
    </div>

    <!-- 滑块 -->
    <div class="sliding m10">
      <!-- .prevent 防止滑动时，页面也跟着滑动 -->
      <div class="slidingBtn" id="Btn">
        <img src="@assets/images/btn_slider.png" />
      </div>
      <div class="slidingTrack" id="Track"></div>
    </div>
    <!-- 底部占位 -->
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    verify: Number,
  },
  data() {
    return {
      positionX: 0, // 划定的距离
      nx: "",
      dx: "",
      xPum: "", // 移动的最终值
      verifyId: 0, // 验证的id
      TrackWidth: 0, // 拖拽的宽度
      DataBigImg: "", // 大图
      Smallimg: "", // 小图
      isLeave: true, // 是否离开元素 判断鼠标是否抬起
    };
  },

  mounted() {
    let _this = this;
    _this.verifyCheck();
  },

  methods: {
    ...mapActions({
      GetSliderVerificationCode: "CommonModule/GetSliderVerificationCode",
      ValidationSliderVerificationCode:
        "CommonModule/ValidationSliderVerificationCode",
    }),
    //按下
    drag() {
      event.stopPropagation();
      event.preventDefault();
      this.isLeave = false;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.positionX = touch.clientX;
      this.dx = Btn.offsetLeft;
      this.TrackWidth = Track.offsetWidth - Btn.offsetWidth;
    },
    //移动
    move() {
      if (this.isLeave) return false;
      event.stopPropagation();
      event.preventDefault();
      if (!this.isLeave) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        this.nx = touch.clientX - this.positionX;
        this.xPum = this.dx + this.nx;
        if (this.xPum <= 0) {
          Btn.style.left = 0 + "px";
          bigimg.style.left = 0 + "px";
        } else if (this.xPum >= this.TrackWidth) {
          Btn.style.left = this.TrackWidth + "px";
          bigimg.style.left = this.TrackWidth + "px";
        } else {
          Btn.style.left = this.xPum + "px";
          bigimg.style.left = this.xPum + "px";
        }
      }
    },
    leave() {
      event.stopPropagation();
      event.preventDefault();
      this.isLeave = true;
      Btn.style.left = 0 + "px";
      bigimg.style.left = 0 + "px";
    },
    //松开
    end() {
      event.stopPropagation();
      event.preventDefault();
      this.isLeave = true;
      this.SliderVerify();
    },

    // 刷新
    refresh() {
      this.$message({
        type: "success",
        message: "刷新成功",
      });
      this.verifyCheck();
    },

    // 失败
    Err() {
      Btn.style.left = 0 + "px";
      bigimg.style.left = 0 + "px";
    },

    //获取验证码
    verifyCheck() {
      var _this = this;
      let request_data = {
        id: _this.verifyId,
      };
      _this.GetSliderVerificationCode(request_data).then((res) => {
        _this.verifyId = res.id;
        _this.DataBigImg = res.bigImg;
        _this.Smallimg = res.smallImg;
        _this.xPum = 0;
      });
    },

    // 验证码校正
    SliderVerify() {
      let _this = this;
      let sceld = $("#DataBigImg")[0].clientWidth / 310;
      let requestX = Math.round(_this.xPum / sceld);
      let request_data = {
        id: _this.verifyId,
        x: requestX,
      };
      //滑动超过10px才算, 避免点击误触问题
      if (request_data.x < 10) return;

      _this.ValidationSliderVerificationCode(request_data).then((res) => {
        if (res) {
          _this.$message({
            type: "success",
            message: "验证通过",
          });
          _this.$emit("verifydata", false);
        } else {
          _this.$message({
            type: "error",
            message: "验证失败",
          });
          _this.Err();
          _this.verifyCheck();
        }
      });
    },
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}

.verifyBox {
  /* width: 600px; */
  min-height: 200px;
  /* max-height: 400px; */
  background: #fff;
  z-index: 999;
  cursor: pointer;
  padding: 20px 20px 20px 20px;
}

.m10 {
  margin: 0 12px;
}

.p10 {
  padding: 12px 0;
}

/*  头部  */
.height {
  height: 1.06rem;
  line-height: 1.06rem;
  overflow: hidden;
}

.height .height-left {
  float: left;
  font-size: 14px;
  width: 100%;
  color: #e74c3c;
  font-weight: bold;
  text-align: center;
}

.height .height-right {
  float: right;
}

.height .height-right img {
  width: 0.55rem;
}

/* 滑块图片 */
.drag {
  /* height: 5.3rem; */
  position: relative;
  /* border: 1px solid #000; */
  cursor: pointer;
  margin-top: 10px;
}

.drag .bigimg {
  width: 100%;
}

.drag .bigimg img {
  width: 100%;
}

.drag .smallimg {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.drag .smallimg img {
  height: 100%;
}

/* 滑块 */
.sliding {
  height: 50px;
  position: relative;
  margin: 12px 12px 0 12px;
}

.sliding .slidingBtn {
  position: absolute;
  left: 0;
  z-index: 9;
}

.sliding .slidingBtn img {
  width: 70px;
  height: 40px;
}

.sliding .slidingTrack {
  height: 10px;
  position: absolute;
  top: 40%;
  border-radius: 15px;
  background: #e4e4e4;
  width: 100%;
  transform: translateY(-50%);
}
</style>
